import React, { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { ProtectedContainer } from 'src/components'
import { useAuth } from 'src/contexts/auth'
import { Loading } from 'src/components/Loading'
import { toast } from 'react-toastify'
import ROUTES from 'src/constants/routes'

export const ProtectedLayout = (): JSX.Element => {
  const { user, authenticated, loading, tokenExpired, needsConfirmation } = useAuth()
  const { pathname } = useLocation()

  useEffect(() => {
    const mainContainer = document.getElementById('main-container')
    if (mainContainer) {
      mainContainer.scrollTop = 0
    }
  }, [pathname])

  if (loading) {
    return (
      <div style={{ height: '100vh', display: 'flex', justifyContent: 'center' }}>
        <Loading />
      </div>
    )
  }

  if (!tokenExpired) {
    toast.error('Sua sessão expirou. Faça o login novamente.')
    return <Navigate to={ROUTES.AUTH.LOGIN} replace />
  }

  if (!authenticated) {
    return <Navigate to={ROUTES.AUTH.LOGIN} replace />
  }

  const newPasswordConfirmed =
    user?.senhaResetada &&
    (user.senhaResetada === 'S' || user.senhaResetada === 'true' || user.senhaResetada === 'True')

  if (newPasswordConfirmed) {
    return <Navigate to={ROUTES.AUTH.CHANGE_PASSWORD} replace />
  }

  if (needsConfirmation()) {
    return <Navigate to={ROUTES.AUTH.CONFIRM_PHONE} replace />
  }

  return (
    <ProtectedContainer>
      <Outlet />
    </ProtectedContainer>
  )
}
